import { render } from "./ListOrganizations.vue?vue&type=template&id=e41c4792"
import script from "./ListOrganizations.vue?vue&type=script&lang=js"
export * from "./ListOrganizations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__